import React, { useMemo } from 'react'
import './Events.css'
import Slider from '../components/Slider'
import { eventsImageScrollerData } from '../data/eventsImageScroller'
import { InteractiveQASessionsData, ResearchPresentationsData } from '../data/eventsData'

const Events = () => {

    const getYouTubeVideoId = (url) => {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);
        return (match && match[2].length === 11) ? match[2] : null;
    }


    const getYouTubeThumbnail = (url, quality = 'maxresdefault') => {
        const videoId = getYouTubeVideoId(url);
        return videoId ? `https://img.youtube.com/vi/${videoId}/${quality}.jpg` : null;
    }

    // Transform ResearchPresentationsData to include YouTube thumbnails for the Slider
    const researchSliderData = useMemo(() => {
        return ResearchPresentationsData.map((item, index) => ({
            id: index,
            url: getYouTubeThumbnail(item.url),
            title: item.title,
            location: item.desc,
            link: item.url,
        }));
    }, [])

    return (
        <div className='eventsContainer'>
            <div className='eventsHeader'>
                <div className='eventsHeaderText'>
                    <p className='headerTextTitle'>Events</p>
                    <p className='headerTextDesc'>We frequently organize sessions by women from across the research and policy spectrum. Speakers share their experiences in leading organizations, conducting cutting-edge research, and working as and with policy makers, among other things. These sessions are honest and insightful, and continuously guide and inspire us!</p>
                </div>
                <div className='eventsHeaderContent'>
                    <div className='headerContentImageScroller'>
                        <Slider items={eventsImageScrollerData} delay={3000} pauseOnHover={true} />
                    </div>
                    <div className='headerContentDesc'>
                        <p className='contentDescTitle'>Networking Mixers</p>
                        <p className='contentDescSubTitle'>Meet other women in the field and connect over shared ideas, goals and chaii!</p>
                    </div>
                </div>
            </div>
            <div className='events'>
                <div className='QASessions'>
                    <p className='QASessionsTitle'>Interactive Q&A Sessions</p>
                    <p className='QASessionsDesc'>Listen to the women in the filed talk about their inspiring journeys and path breaking work!</p>
                    <div className='QASessionsGrid'>

                        {InteractiveQASessionsData.map((item, index) => (
                            <a href={item.url} target='_blank' rel='noopener noreferrer' key={index}>
                                <div className='QASessionItem'>
                                    <img
                                        src={getYouTubeThumbnail(item.url)}
                                        alt={item.title}
                                        className='QASessionThumbnail'
                                    />
                                    <h3>{item.title}</h3>
                                    <p>{item.desc}</p>
                                </div>
                            </a>
                        ))}
                    </div>
                </div>
                <div className='ResearchPresentations'>
                    <div className='ResearchSlider'>
                        <Slider items={researchSliderData} delay={6000} pauseOnHover={true} />
                    </div>
                    <div className='ResearchPresentationsContent'>
                        <p className='ResearchPresentationsTitle'>Research Presentations</p>
                        <p className='ResearchPresentationsDesc'>Listen to women talk about their exciting research projects in gender, economics, policy and development!</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Events
